import { render, staticRenderFns } from "./BDXWizardBackButton.vue?vue&type=template&id=ccb8db0a"
import script from "./BDXWizardBackButton.vue?vue&type=script&lang=js"
export * from "./BDXWizardBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports